import React from 'react';
import { Grid, Typography, Box, Link } from '@material-ui/core';

import './local.css';

const StickyNotes = ({ title, content, href, actionText }) => {
  return (
    <Box className="sticky-notes__card">
      <Typography className="home-page__card-title">
        {title}
      </Typography>
      <Typography className="home-page__card-body">
        {content}
      </Typography>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="button" className="home-page__card-goTo">
          <Link href={href} target="_blank" rel="noopener">
            {actionText}
          </Link>
        </Typography>
      </Box>
    </Box>
  );
};

export default StickyNotes;

